import { createFileRoute } from '@tanstack/react-router';

import { TravelSettingsEdit } from '@/module/Travel/Settings/TravelSettingsEdit';

export const Route = createFileRoute('/_auth/travel/_travel/settings/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TravelSettingsEdit />;
}
